"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LengthUnitSchema = void 0;
const zod_1 = require("zod");
exports.LengthUnitSchema = zod_1.z.enum(['km', 'm', 'cm', 'mm', 'um', 'mil', 'inch', 'ft']);
exports.default = exports.LengthUnitSchema;
//# sourceMappingURL=LengthUnitSchema.js.map